/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-03-09 16:30:27
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-11-28 19:44:33
 */

import React from "react";
import { HashRouter as Router } from "react-router-dom";
//import { BrowserRouter as Router } from "react-router-dom";
import { renderRoutes } from "assets/renderRouter";
import Loadable from "react-loadable"; //按需加载路由插件
import { Provider } from "react-redux";
import { store } from "../tools/store";
import Music from "components/music"

const MyLoadingComponent = (v: { isLoading: any; error: any }) => {
  if (v.isLoading) {
    return <div>Loading...</div>;
  } else if (v.error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};
// 报错页
const Error = Loadable({
  loader: () => import("../views/error"),
  loading: MyLoadingComponent,
});
// 首页
const Landing = Loadable({
  loader: () => import("../views/landing"),
  loading: MyLoadingComponent,
});
// 创建卡片
const Create = Loadable({
  loader: () => import("../views/create"),
  loading: MyLoadingComponent,
});
// 排行榜
const RankList = Loadable({
  loader: () => import("../views/ranklist"),
  loading: MyLoadingComponent,
});
// 规则
const Rules = Loadable({
  loader: () => import("../views/rules"),
  loading: MyLoadingComponent,
});
const routes = [
  {
    path: "/error", //报错页
    component: Error,
  },
  {
    path: "/landing",
    component: Landing,
  },
  {
    path: "/create",
    component: Create,
  },
  {
    path: "/rankinglist",
    component: RankList,
  },
  {
    path: "/rules",
    component: Rules,
  },
  {
    path: "/",
    redirect: "/landing",
  },
];

const mRoute = () => {
  return (
    <Provider store={store}>
      <Music />
      <Router>{renderRoutes(routes)}</Router>
    </Provider>
  );
};

export default mRoute;
